"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _spacing = require("@amzn/meridian-tokens/base/spacing");

var _progressTrackerContext = _interopRequireDefault(require("./progress-tracker-context"));

var _progressTrackerMilestone = _interopRequireDefault(require("./progress-tracker-milestone"));

var _progressTrackerTrack = _interopRequireWildcard(require("./progress-tracker-track"));

var _token = require("./../_utils/token");

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var direction = _ref.direction;
  return (0, _emotion.css)({
    // Reset the default margin on figure tags
    margin: "0",
    display: "flex",
    flexDirection: direction === "row" ? "column" : "row",
    "& [role=img]": {
      display: "flex",
      flexDirection: direction
    }
  });
}, ["direction"]);
var contentStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var _css;

  var direction = _ref2.direction,
      rowLabelAlignment = _ref2.rowLabelAlignment,
      trackLength = _ref2.trackLength,
      size = _ref2.size,
      lastStep = _ref2.lastStep;

  var _getTrackDimensions = (0, _progressTrackerTrack.getTrackDimensions)(t, {
    length: trackLength,
    size: size
  }),
      lengthInPx = _getTrackDimensions.lengthInPx,
      widthInPx = _getTrackDimensions.widthInPx;

  var milestoneDiameter = t("milestoneDiameter", size);
  var column = direction === "column";
  var row = !column;
  var rowCenter = row && rowLabelAlignment === "center";
  return (0, _emotion.css)((_css = {
    display: "flex",
    flexDirection: "column",
    flex: "auto",
    alignItems: rowCenter ? "center" : row ? "flex-start" : "stretch",
    // Constrain the width of the label and children in a horizontal progress
    // tracker to the width of a milestone. This won't actually squish the
    // content into the width of a milestone because the label and children
    // have their own widths set to the length of the track, but it will
    // ensure that the label and children don't affect the overall width of
    // the progress tracker in the page layout (making it easier to center the
    // progress tracker).
    width: rowCenter ? milestoneDiameter : undefined
  }, (0, _defineProperty2["default"])(_css, row ? "paddingTop" : "paddingLeft", widthInPx), (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", (0, _defineProperty2["default"])({}, row ? "paddingTop" : "paddingRight", widthInPx)), (0, _defineProperty2["default"])(_css, "& [mdn-progress-tracker-step-label]", {
    display: "flex",
    alignItems: "center",
    justifyContent: rowCenter ? "center" : undefined,
    textAlign: rowCenter ? "center" : undefined,
    width: row ? lengthInPx : undefined,
    height: row ? undefined : milestoneDiameter
  }), (0, _defineProperty2["default"])(_css, "& [mdn-progress-tracker-step-children]", {
    boxSizing: "border-box",
    display: "flex",
    flex: "auto",
    justifyContent: rowCenter ? "center" : undefined,
    textAlign: rowCenter ? "center" : undefined,
    width: row ? lengthInPx : undefined,
    // Don't constrain the height of the children for the last step (there
    // are no more steps below that we have to worry about overlapping)
    height: column && !lastStep ? lengthInPx : undefined,
    paddingTop: column && size === "small" ? _spacing.spacingXsmall : undefined,
    overflow: "hidden"
  }), _css));
}, ["direction", "rowLabelAlignment", "trackLength", "size", "lastStep"]);
var hiddenStyles = (0, _emotion.css)({
  display: "none"
});
/**
 * @since 4.x
 */

function ProgressTrackerStep(props) {
  var context = (0, _react.useContext)(_progressTrackerContext["default"]);
  var id = (0, _react.useMemo)(function () {
    return (0, _uniqueId["default"])("mdn-pt-step-");
  }, []);
  var lastStep = !context.nextStepType;
  var showLabel = props.showLabel === undefined ? context.size === "large" : props.showLabel; // If we aren't showing the label, construct a title for the image

  var title = undefined;

  if (!showLabel) {
    title = typeof props.label === "string" ? props.label : "";
  }

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: styles(context.t, {
      direction: context.direction
    })
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    role: "img",
    "aria-labelledby": "".concat(id, "-label ").concat(id, "-label-type"),
    "aria-describedby": props.children ? "".concat(id, "-children") : undefined,
    title: title
  }, passThroughProps), /*#__PURE__*/_react["default"].createElement(_progressTrackerMilestone["default"], {
    type: props.type,
    size: context.size,
    alert: props.alert,
    showIcon: props.showIcon,
    neutral: context.neutral
  }), !lastStep ? /*#__PURE__*/_react["default"].createElement(_progressTrackerTrack["default"], {
    direction: context.direction,
    size: context.size,
    length: props.trackLength,
    neutral: context.neutral,
    type: context.nextStepType === "past" || context.nextStepType === "present" ? "past" : props.type === "present" || props.type === "future" ? "future" : "present"
  }) : null), /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": "true",
    className: showLabel ? contentStyles(context.t, {
      direction: context.direction,
      rowLabelAlignment: context.rowLabelAlignment,
      trackLength: props.trackLength,
      size: context.size,
      lastStep: lastStep
    }) : hiddenStyles
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "".concat(id, "-label"),
    "mdn-progress-tracker-step-label": ""
  }, props.label), props.children ? /*#__PURE__*/_react["default"].createElement("div", {
    id: "".concat(id, "-children"),
    "mdn-progress-tracker-step-children": ""
  }, props.children) : null, /*#__PURE__*/_react["default"].createElement("div", {
    id: "".concat(id, "-label-type"),
    className: hiddenStyles
  }, {
    past: context.labelPast,
    present: context.labelPresent,
    future: context.labelFuture
  }[props.type])));
}

ProgressTrackerStep.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A label for the step.
   *
   * This should describe what the step represents (e.g.
   * "Shipped" or "Delivered"). This is required to ensure the progress tracker
   * is accessible. This should be relatively short, use the `children` prop for
   * long content.
   *
   * This will not be visible in the UI for compact progress
   * trackers. If you do not wish to show this in the UI for non-compact
   * progress trackers you can set the "showLabel" prop to false.
   */
  label: _propTypes["default"].node.isRequired,

  /**
   * The temporal state of the step.
   */
  type: _propTypes["default"].oneOf(["past", "present", "future"]).isRequired,

  /**
   * Set this to show the step in an alert state.
   */
  alert: _propTypes["default"].oneOf(["error", "warning", "none"]),

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the ProgressTrackerStep component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-labelledby | aria-describedby
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Additional content to render below the step's label. This will only be
   * visible if the label is visible.
   */
  children: _propTypes["default"].node,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * An id for the step that is unique among the other steps in the same
   * progress tracker.
   *
   * This is only necessary if you plan to add, remove, or
   * re-order steps after they are first rendered. Note that this id is not
   * rendered to the DOM, this is simply used to track the step internally.
   */
  id: _propTypes["default"].string,

  /**
   * Show an icon in the step's milestone circle.
   *
   * This only applies to steps that are not in an alert state and are rendered
   * in non-compact progress trackers.
   */
  showIcon: _propTypes["default"].bool,

  /**
   * Show the step's label (and children) in the UI.
   *
   * This defaults to true for regular progress trackers and false for compact
   * progress trackers.
   */
  showLabel: _propTypes["default"].bool,

  /**
   * Use this to adjust the step's track length.
   *
   * Note that this is not a pixel value, this is the number of "dots" that make up the track. This must be an
   * even integer (other numbers will be rounded to the nearest even integer).
   * This prop will not affect the display of the last step in the progress
   * tracker (the last step does not have a track associated with it).
   */
  trackLength: _propTypes["default"].number
} : {};
ProgressTrackerStep.defaultProps = {
  alert: "none",
  trackLength: 6,
  showIcon: true
};
var _default = ProgressTrackerStep;
exports["default"] = _default;